import React from 'react';
import { Options } from 'nouislider';
import { Nouislider, NouisliderProps } from './Nouislider';
import 'nouislider/distribute/nouislider.css';
import { SerializedStyles } from '@emotion/react';

import {
  ChildrenElement,
  Container,
  LabelLeft,
  LabelRight,
  SliderHead,
  SliderWrapper
} from './styles';

export interface SliderProps extends Options, NouisliderProps {
  children?: React.ReactNode;
  width?: string | number;
  height?: string | number;
  clickablePips?: boolean;
  labelLeft?: React.ReactNode;
  labelRight?: React.ReactNode;
  styles?: {
    wrapper?: SerializedStyles;
  };
}

export const Slider = (props: SliderProps) => {
  const hasLabel = props.labelLeft || props.labelRight;

  return (
    <Container width={props.width} height={props.height} hasPips={!!props.pips}>
      {hasLabel && (
        <SliderHead>
          <LabelLeft>{props.labelLeft}</LabelLeft>
          <LabelRight>{props.labelRight}</LabelRight>
        </SliderHead>
      )}
      <SliderWrapper css={props.styles?.wrapper}>
        <ChildrenElement>{props.children}</ChildrenElement>
        {/* @ts-ignore */}
        <Nouislider {...props} />
      </SliderWrapper>
    </Container>
  );
};
